<div id="caption">
  <p>{{section['question'] |  translate:'LOCALE':'text'}}</p>
</div>